// @flow

import { createStackNavigator } from '@react-navigation/stack';
import { StackActions } from '@react-navigation/native';

const Stack = createStackNavigator();

export const navigateWithoutHistory = (navigation, screenName, params = undefined) => {
    navigation.dispatch((state) => {
        const oldRoute = state.routes.find((route) => route.name === screenName);
        if (oldRoute) {
            // If the old route is available, navigate to it
            return StackActions.replace(screenName, params);
        }
        return StackActions.push(screenName, params);
    });
};

export default Stack;
